<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Finances
            </v-row>
            <v-divider />
            <!--table 1 head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers.tab_1" :key="i" class="tabCell" 
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <!--finances tab 1-->
            <div v-if="finances?.length > 0">
                <div v-for="item in finances" :key="item.id">
                    <v-row no-gutters >
                        <v-col class="text-left tabCell">{{ item.team.name }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.fixed_assets, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.accumulated_depreciation, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.cash, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.inventories, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.contributed_capital, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.retained_profit, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.long_term_debt, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.growth_finances, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.accum_write_off, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.sales, 0) }}</v-col>
                    </v-row>
                </div>


                <v-divider class="mt-12"/>
                <!--table 2 head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col v-for="(item, i) in headers.tab_2" :key="i" class="tabCell" 
                        :class="item.style">
                        {{ item.title }}
                    </v-col>
                </v-row>
                <!--finances tab 2-->
                <div v-for="item in finances" :key="`tab_2_${item.id}`">
                    <v-row no-gutters>
                        <v-col class="text-left tabCell">{{ item.team.name }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.profit_current_round, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.other_incomes, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.CoGs, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.ga_expenses, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.ms_expenses, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.rd_expenses, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.depreciation, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.interests, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.investments, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.borrowings, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.emergency_loan, 0) }}</v-col>
                    </v-row>
                </div>
            </div>

        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import { localeNumber, roundNumber } from '../../../functions/common';
export default {
    data() {
        return {
            headers:{
                tab_1 : [
                    { title: 'Team', style: 'text-left' },
                    { title: 'Fixed assets', style: 'text-center' },
                    { title: 'Accumulated depreciation', style: 'text-center' },
                    { title: 'Cash', style: 'text-center' },
                    { title: 'Inventories', style: 'text-center' },
                    { title: 'Contributed capital', style: 'text-center' },
                    { title: 'Retained profit', style: 'text-center' },
                    { title: 'Long term debt', style: 'text-center' },
                    { title: 'Growth finances', style: 'text-center' },
                    { title: 'Accum write off', style: 'text-center' },
                    { title: 'Sales', style: 'text-center' }, 
                ],
                tab_2: [
                    { title: 'Team', style: 'text-left' },
                    { title: 'Profit current round', style: 'text-center' },
                    { title: 'Other incomes', style: 'text-center' },
                    { title: 'CoGs', style: 'text-center' },
                    { title: 'G&A expenses', style: 'text-center' },
                    { title: 'M&S expenses', style: 'text-center' },
                    { title: 'R&D expenses', style: 'text-center' },
                    { title: 'Depreciation current round', style: 'text-center' },
                    { title: 'Interests', style: 'text-center' },
                    { title: 'Investments current round', style: 'text-center' },
                    { title: 'Borrowings', style: 'text-center' },
                    { title: 'Emergency loan', style: 'text-center' },
                ],
            },
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        finances() {
            return this.$store.getters.finances_all;
        },
    },
    methods: {
        localeNumber(number) {
            return localeNumber(number, this.locale)
        },
        formatNumber(num, dec) {
            return localeNumber(roundNumber(num, dec), this.locale);
        }
    },
    components: { Loader }
}
</script>